export default "__VITE_ASSET__B2mbx$_d__"